import type { HTMLAttributes } from 'react';

import { cn } from '../utils/cn';

/**
 * Accordion is just a styled vertical stack — the open/close logic is driven
 * by the wizard machine, not by the accordion itself. This keeps the FSM as
 * the single source of truth for which step is active.
 */
export const Accordion = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col gap-3', className)} {...props} />
);
